import { AlertBox } from '@core/components/AlertBox';
import { environment } from '@core/environment';
import { MenuBar } from '@menu/components';
import { ProjectDetail, ProjectsList, ScanRedirect } from '@projects/pages';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

const { basePath } = environment;

export const Router = () => (
  <BrowserRouter basename={basePath ? `/${basePath}` : '/'}>
    <MenuBar />
    <Routes>
      <Route path="/projects/list" element={<ProjectsList />} />
      <Route path="/projects/:projectId" element={<ProjectDetail />} />
      <Route path="/projects/:projectId/scans/:scanId" element={<ProjectDetail />} />
      <Route path="/projects/:projectId/scan/:scanId" element={<ProjectDetail />} />
      <Route path="/scans/:scanId" element={<ScanRedirect />} />
      <Route path="/scan/:scanId" element={<ScanRedirect />} />
      <Route path="*" element={<Navigate replace to="/projects/list" />} />
    </Routes>
    <AlertBox />
  </BrowserRouter>
);
